import React, { Component } from "react";
import { Box, Button, Typography, Card, Grid } from "@mui/material";
import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
import CtDtp from "./CustomTool/CtDtp";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import { connect } from "react-redux";
import {
  mapSetUserPrivileges_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import { withRouter } from "../HOC/withRouter";
import { useNavigate } from "react-router-dom";
import { get_YMD_from_SYS } from "../SystemUtility/SystemUtility";

class Final extends Component {
  state = {
    formData: {
      advancePaymentDate: get_YMD_from_SYS(new Date()),
      advancePaymentMode: "",
      advanceReceiveAmount: "",
      advanceTdsAmount: "",
      advanceTotalAmount: "",
      advanceRemark: "",
    },
  };
  componentDidMount() {
    document.title = "Final Advance Payment AMC";
    localStorage.setItem("Heading", "Final Advance Payment AMC");
    this.props.verifyUserID(this.getInfo, this.props.setUserPrivileges);
  }
  getInfo = () => {
    document.getElementById("advancePaymentDate")?.focus();
  };
  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  validateFinal = () => {
    const { formData } = this.state;
    if (!formData.advancePaymentDate) {
      this.props.toastErrorMsg("Select Payment Date", "advancePaymentDate");
      return false;
    }

    if (!formData.advancePaymentMode) {
      this.props.toastErrorMsg("Select Payment Mode", "advancePaymentMode");
      return false;
    }

    if (!formData.advanceReceiveAmount) {
      this.props.toastErrorMsg("Enter Receive Amount", "advanceReceiveAmount");
      return false;
    }

    if (!formData.advanceTotalAmount) {
      this.props.toastErrorMsg("Enter Total Amount", "advanceTotalAmount");
      return false;
    }
    return true;
  };

  handleSubmit = () => {
    if (this.validateFinal()) {
      this.props.toastMsg("success", "Final Advance Payment Save Successfully");
      this.clearInfo();
      // this.props.navigateTo("AMCRegistration");
    }
  };

  clearInfo = () => {
    this.setState({
      formData: {
        // advancePaymentDate: "",
        advancePaymentMode: "",
        advanceReceiveAmount: "",
        advanceTdsAmount: "",
        advanceTotalAmount: "",
        advanceRemark: "",
      },
    });
  };

  render() {
    const { formData } = this.state;

    return (
      <form>
        {" "}
        <Box sx={{ padding: "12px 8px 4px" }}>
          {/* <Typography
            align="center"
            fontWeight={700}
            fontSize="22px"
            marginBottom="18px"
          >
            Final Advance Payment AMC
          </Typography> */}

          <Card sx={{ padding: 2, width: 400, boxShadow: 2 }}>
            <Grid container spacing={2}>
              <Grid item>
                <CtDtp
                  id="advancePaymentDate"
                  label="Payment Date*"
                  value={formData.advancePaymentDate}
                  width={160}
                  maxLength={100}
                  handleOnChange={this.handleOnChange}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID={"advancePaymentMode"}
                />
              </Grid>

              <Grid item>
                <CtCmbEditable
                  id="advancePaymentMode"
                  label="Payment Mode*"
                  value={formData.advancePaymentMode}
                  items={[
                    { name: "Cash" },
                    { name: "Cheque" },
                    { name: "NEFT" },
                    { name: "UPI" },
                  ]}
                  colID="name"
                  width={160}
                  maxLength={100}
                  handleOnChange={this.handleOnChange}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID={"advanceReceiveAmount"}
                />
              </Grid>

              <Grid item>
                <CtTxtAmt
                  id="advanceReceiveAmount"
                  label="Receive Amount*"
                  value={formData.advanceReceiveAmount}
                  width={160}
                  maxLength={100}
                  handleOnChange={this.handleOnChange}
                  onKeyDown={this.props.onKeyDown}
                />
              </Grid>

              <Grid item>
                <CtTxtAmt
                  id="advanceTdsAmount"
                  label="TDS Amount"
                  value={formData.advanceTdsAmount}
                  width={160}
                  maxLength={100}
                  handleOnChange={this.handleOnChange}
                  onKeyDown={this.props.onKeyDown}
                />
              </Grid>

              <Grid item>
                <CtTxtAmt
                  id="advanceTotalAmount"
                  label="Total Amount*"
                  value={formData.advanceTotalAmount}
                  width={160}
                  maxLength={100}
                  handleOnChange={this.handleOnChange}
                  onKeyDown={this.props.onKeyDown}
                />
              </Grid>

              <Grid item>
                <CtMultiLineText
                  id="advanceRemark"
                  label="Remark"
                  value={formData.advanceRemark}
                  width={160}
                  maxLength={1000}
                  handleOnChange={this.handleOnChange}
                  // onKeyDown={this.props.onKeyDown}
                />
              </Grid>
            </Grid>
          </Card>

          {/* Buttons */}
          <Box
            sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 2 }}
          >
            <Button
              variant="contained"
              startIcon={<CheckBoxOutlinedIcon />}
              sx={{ textTransform: "none", fontWeight: 600 }}
              onClick={this.handleSubmit}
            >
              Active
            </Button>

            {/* <Button
              variant="outlined"
              sx={{ textTransform: "none", fontWeight: 600 }}
              onClick={this.clearInfo}
            >
              Clear
            </Button> */}
          </Box>
        </Box>
      </form>
    );
  }
}

function WithNavigate(props) {
  const navigate = useNavigate();
  return <Final {...props} navigate={navigate} />;
}

export default connect(
  mapStatetoProps,
  mapSetUserPrivileges_ToProps,
)(HoCtToastContainer(HOCVerifyIsUser(withRouter(WithNavigate))));
